<template>
  <div class="card-wrapper">
    <b-card v-for="district in districts" :key="district.id" class="mb-3">
      <div class="d-xs-flex justify-content-between align-items-center">
        <div class="d-lg-flex d-block flex-grow-1">
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ district.name_en }}
          </p>
          <p class="card-text w-40 w-sm-100 mb-lg-0 mb-2 mr-2">
            {{ district.name_ru }}
          </p>
        </div>

        <div class="actions d-flex justify-content-end mt-xs-0 mt-4">
          <i @click="showInfoModal(district.id)" class="glyph-icon simple-icon-pencil datalist-icon mr-md-3 mr-2"></i>

          <i @click="handleDelete(district.id)" class="glyph-icon simple-icon-trash datalist-icon"></i>
        </div>
      </div>
    </b-card>

    <!-- Modals -->
    <b-modal id="editDistrictModal" ref="editDistrictModal" size="lg" :title="'Edit District'">
      <b-row v-if="!mLoading">
        <b-colxx xxs="12">
          <b-card class="mb-4">
            <b-form @submit.prevent="onSubmit" class="av-tooltip">
              <b-form-group :label="$t('pages.districts.districtNameEn')">
                <b-form-input type="text" v-model="$v.editForm.nameEn.$model" :state="!$v.editForm.nameEn.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameEn.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group :label="$t('pages.districts.districtNameRu')">
                <b-form-input type="text" v-model="$v.editForm.nameRu.$model" :state="!$v.editForm.nameRu.$error" />
                <b-form-invalid-feedback v-if="!$v.editForm.nameRu.required">
                  {{ $t('formErrors.enterName') }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-2">
                {{ $t('buttons.save') }}
              </b-button>
            </b-form>
          </b-card>
        </b-colxx>
      </b-row>
      <div v-else class="d-flex justify-content-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>

      <template slot="modal-footer">
        <b-button variant="secondary" @click="hideModal('editDistrictModal')">
          {{ $t('buttons.cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { apiUrl } from '@/constants/config'

const { required } = require('vuelidate/lib/validators')
export default {
  props: {
    districts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      apiUrl,
      mLoading: false,
      editForm: {
        nameEn: '',
        nameRu: ''
      },
      currentDistrict: null
    }
  },
  validations: {
    editForm: {
      nameEn: { required },
      nameRu: { required }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (_bvEvent, modalId) => {
      if (modalId === 'editDistrictModal') {
        this.clearForm()
      }
    })
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 3000, permanent: false })
    },
    handleDelete(id) {
      this.$confirm({
        message: this.$t('confirm-dialog.question'),
        button: {
          no: this.$t('confirm-dialog.no'),
          yes: this.$t('confirm-dialog.yes')
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('districts/deleteDistrict', {
              id,
              vm: this
            })
          }
        }
      })
    },
    showInfoModal(id) {
      this.$bvModal.show('editDistrictModal')
      this.$store.dispatch('districts/fetchDistrict', { id, vm: this })
      this.currentDistrict = id
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          name_en: this.editForm.nameEn,
          name_ru: this.editForm.nameRu
        }

        this.$store.dispatch('districts/updateDistrict', {
          payload,
          id: this.currentDistrict,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.nameEn = ''
      this.editForm.nameRu = ''
      this.currentDistrict = null
    },
    hideModal(refname) {
      this.$refs[refname].hide()
    }
  }
}
</script>
